import pageClass from '@/unit/pageClass'

class searchFrom extends pageClass {
  constructor(type) {
    super()
    if (type === 'form') {
      this.matchId = ''
      this.useFlag = ''
    }
  }
}
export default searchFrom
